export default __webpack_public_path__ + "static/media/grafema_amcc_06.2a79c716.jpg";